import { projectDataType } from ".";

const intangibilityData: projectDataType = {
  path: "intangibility",
  title: "Intangibility",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965232/Art-Site/Intangibility/_mg_8732-fixed_x3kxdo.jpg",
  description:
    "An immersive sculptural installation collaboration created collaboratively between Lauren Pascarella and Giselle Zatonyl. Installed at the Freedom Tower in Miami.",
  year: 2014,
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965232/Art-Site/Intangibility/_mg_8732-fixed_x3kxdo.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965232/Art-Site/Intangibility/_mg_8722-fixed_jhm9pi.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965233/Art-Site/Intangibility/_mg_8732-fixed3-u9995-fr_lcdgvp.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965232/Art-Site/Intangibility/_mg_8722-fixed2_bxymu8.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965232/Art-Site/Intangibility/_mg_8721-fixed_turann.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965231/Art-Site/Intangibility/_mg_8736-fixed_uylas4.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965232/Art-Site/Intangibility/_mg_8725-fixed_qfw5xy.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965232/Art-Site/Intangibility/_mg_8717-fixed_yfoqby.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965233/Art-Site/Intangibility/_mg_8727-fixed_lt2hly.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965233/Art-Site/Intangibility/_mg_8742-fixed_jrayrt.jpg",
  ],
};

export default intangibilityData;
